import styled from 'styled-components';
import StockModelCardOptionsTemplate from './StockModelCardOptionsTemplate';
import { rem } from 'polished';

export const InformationTooltip = styled.div<{ isVisible: boolean }>`
    visibility: ${(props) => (props.isVisible ? 'none' : 'hidden')};
    opacity: ${(props) => (props.isVisible ? '1' : '0')};
    transition: visibility 0s linear 100ms, opacity 800ms;
    position: absolute;
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
    width: 197px;
    margin-left: 25px;
    border-radius: 3px;
    padding: 2px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
    border: 1px solid #6d6d6d;
    z-index: 999;
`;

export const TooltipWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;

    .indicator {
        position: absolute;
        left: -10px;
        svg {
            width: 10px;
            height: 10px;
        }
    }
`;

export const IconContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;

    .information {
        width: ${rem('16px')};
        height: ${rem('16px')};
    }

    margin-left: ${rem('15px')};
    cursor: pointer;
`;

export const StockModelCardOptionsStyled = styled(StockModelCardOptionsTemplate)`
    padding: 0 ${rem('20px')} ${rem('10px')};
    position: relative;
    flex-grow: 1;

    .has-options {
        margin-top: ${rem('25px')};
        height: ${rem('10px')} !important;
    }

    .stockModel-tooltip {
        display: flex;
        cursor: pointer;
        align-items: center;
        input {
            display: none;
        }

        span {
            font-size: ${rem('13px')};
            color: ${({ theme }) => theme.colors.primary};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        .checkmark {
            font-size: ${rem('24px')};
            margin-right: ${rem('6px')};
            position: relative;
        }
    }

    .stockModelCard-options {
        &--tooltipItem {
            margin-top: ${rem(55)};
            display: flex;
            align-items: center;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        &--heading {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            text-transform: uppercase;
        }

        &--tooltipItemList {
            padding-left: ${rem('25px')};
            padding-right: ${rem('8px')};
        }

        &--tooltipItemListLi {
            font-size: ${rem('10px')};
            line-height: ${rem('15px')};
        }

        &--list {
            font-size: ${rem('13px')};
            list-style: none;
            padding: 0;
            margin-bottom: ${rem('13px')};
        }

        &--item {
            position: relative;
            margin-left: ${rem('6px')};

            &:not(:last-of-type) {
                margin-bottom: ${rem('5px')};
            }

            &::before {
                position: absolute;
                content: '';
                top: 50%;
                transform: translateY(-50%);
                left: ${rem('-6px')};
                background-color: ${({ theme }) => theme.colors.primary};
                border-radius: 50%;
                width: ${rem('3px')};
                height: ${rem('3px')};
            }
        }

        &--fullList {
            position: absolute;
            bottom: ${rem('-20px')};
            left: ${rem('100px')};
            font-size: ${({ theme }) => theme.fontSizes.textSmall};
            list-style: none;
            padding: 0;
            color: ${({ theme }) => theme.colors.white};
            background-color: ${({ theme }) => theme.colors.default};
            width: ${rem('190px')};
            padding: ${rem('13px')} 0;
            z-index: 15;

            &::before {
                position: absolute;
                content: '';
                left: ${rem('-10px')};
                bottom: ${rem('10px')};
                width: ${rem('20px')};
                height: ${rem('20px')};
                background-color: ${({ theme }) => theme.colors.default};
                transform: rotate(45deg);
            }

            &__heading {
                font-size: ${rem('13px')};
                margin: 0 ${rem('13px')} ${rem('13px')};
                line-height: 1;
            }

            &__item {
                font-size: ${rem('11px')};
                margin: ${rem('3px')} ${rem('10px')} ${rem('3px')} ${rem('20px')};
                line-height: 1.2;
                position: relative;

                &::before {
                    position: absolute;
                    content: '';
                    /* to get top position just summ the margin top + bot */
                    top: ${rem('6px')};
                    transform: translateY(-50%);
                    /* to get left position just double the width of pseudo */
                    left: ${rem('-6px')};
                    background-color: ${({ theme }) => theme.colors.white};
                    border-radius: 50%;
                    width: ${rem('3px')};
                    height: ${rem('3px')};
                }
            }
        }
    }
`;
